import { clubApi } from "../axios";
import { BarberDashboardOverview } from "./types";
export interface BarberDashboardFilter { fromDate?: string; toDate?: string; merchantUserId?: number }
export const getBarberOverview = async (params: BarberDashboardFilter) =>
  (await clubApi.instance.get<BarberDashboardOverview>("/api/BarberDashboard/Overview", { params })).data;
